import styled from 'styled-components';
import { background, border, color, compose, flexbox, grid, layout, position, shadow, space, typography } from 'styled-system';
const styleProps = compose(background, border, color, flexbox, grid, layout, position, shadow, space, typography);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const TableRow = styled.tr<any>`
  color: inherit;
  display: table-row;
  outline: 0;
  vertical-align: middle;

  ${styleProps}
`;